import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const ChatColorful = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path
          stroke="#1D2939"
          strokeWidth={1.5}
          d="M19.071 19.07c-3.055 3.056-7.581 3.717-11.285 2.004-.546-.22-4.085.76-4.853-.007-.767-.768.213-4.307-.007-4.854-1.713-3.702-1.052-8.23 2.004-11.286 3.901-3.903 10.24-3.903 14.141 0 3.91 3.909 3.901 10.241 0 14.143"
          clipRule="evenodd"
        />
        <path
          stroke="#FF6A00"
          strokeWidth={2}
          d="M15.94 12.412h.008M11.93 12.412h.01M7.921 12.412h.01"
        />
      </g>
    </svg>
  );
};
export default ChatColorful;
